import {
  CSN_SEARCH_FILTERS_FACT_TYPE,
  FACT_VERSION,
  getPageUrl,
  SEARCH_RESULTS_FILTERS_PAGE,
  SEARCH_TYPE_AUTOCOMPLETE
} from '@/utils/analyticsClientHelper';
import type { FilterSortFact } from '@/analytics/models/cventAnalytics/FilterSortFact';

export default function getFilterSortFact(
  accountIdHash: string,
  filter: string,
  sortConfigVariantId: number,
  page: number,
  searchedLocation: string,
  isMapExpanded: boolean,
  sort: string,
  referrer: string | null,
  isAIMode?: string
): FilterSortFact {
  return {
    type: CSN_SEARCH_FILTERS_FACT_TYPE,
    account_id_hash: accountIdHash,
    active_filters: filter,
    csn_search_sort_config_exp_variant_id: sortConfigVariantId,
    current_page_number: page,
    page: SEARCH_RESULTS_FILTERS_PAGE,
    search_type: SEARCH_TYPE_AUTOCOMPLETE,
    searched_location: searchedLocation,
    map_view: isMapExpanded ? 'EXPANDED' : 'COLLAPSED',
    page_url: getPageUrl(),
    sort_type: sort,
    referrer,
    ver: FACT_VERSION,
    search: isAIMode === 'true' ? 'AI_SEARCH' : 'CLASSIC_SEARCH'
  };
}
